import { render, staticRenderFns } from "./NoQoutes.vue?vue&type=template&id=ce4a9666&scoped=true"
import script from "./NoQoutes.vue?vue&type=script&lang=js"
export * from "./NoQoutes.vue?vue&type=script&lang=js"
import style0 from "./NoQoutes.vue?vue&type=style&index=0&id=ce4a9666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4a9666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
